export const defaultLocale = "en";
export const maximumProcessableCommands = 100;
export var CommandName;
(function (CommandName) {
    CommandName["createOnPageDialog"] = "create_on_page_dialog";
    CommandName["createTab"] = "create_tab";
})(CommandName || (CommandName = {}));
export const CommandVersion = {
    [CommandName.createOnPageDialog]: 8,
    [CommandName.createTab]: 6,
};
